<template>
    <b-container fluid class="overview">
        <h1 class="text-left">{{ $t('menuItemOwsService') }}</h1>
        <br />
        <b-row>
            <!-- Search field -->
            <search-box
                id="searchOWSServiceType"
                @input="$_onInput"
                :info="$t('searchInfo')"
                :autofocus="true"
                :value="searchText"
                :saveInState="true"
            >
            </search-box>
            <!-- OWS service type filter field -->
            <x-select
                :id="`selectOWSServiceType`"
                :name="`selectOWSServiceType`"
                @selected="$_onOwsServiceType"
                :options="$_owsServiceTypeOptions"
                :textDefaultOption="$t('typeFilter')"
                :value="selectedOwsServiceType"
                :saveInState="true"
            >
            </x-select>
            <b-link class="px-3 pt-2" @click="$_clearFilters()">
                {{ $t('clearFilters') }}
            </b-link>
        </b-row>
        <!-- Overview Table -->
        <b-table
            id="owsoverview"
            striped
            hover
            small
            outlined
            bordered
            v-show="dataLoaded"
            @row-clicked="$_onDetails"
            :tbody-tr-class="$_rowClass"
            :items="filteredRecords"
            :fields="fields"
            :sort-by.sync="sortBy"
            sort-icon-left
        >
            <template v-slot:cell(isUnavailable)="data">
                <em
                    title="Ows service niet beschikbaar"
                    class="error"
                    :class="data.value"
                ></em>
            </template>
        </b-table>
        <!-- No content for overview -->
        <b-row>
            <b-col md="12" v-show="!dataLoaded">
                <span>{{ $t('owsNotPresent') }}</span>
            </b-col>
        </b-row>
        <router-links-footer :routerLinks="[{ name: 'owsDetailNew' }]" />
    </b-container>
</template>

<script>
    import SearchBox from '../../components/SearchBox.vue';
    import XSelect from '../../components/BaseComponents/x-select.vue';
    import RouterLinksFooter from '../../components/dashboard/RouterLinksFooter.vue';
    import {
        getOwsType,
        owsServiceTypeOptions,
        nprogress
    } from '../../services/utilities';

    export default {
        name: 'OwsOverview',

        components: {
            'search-box': SearchBox,
            'x-select': XSelect,
            'router-links-footer': RouterLinksFooter
        },

        data: function () {
            return {
                sortBy: 'name',
                fields: [
                    {
                        key: 'name',
                        label: this.$t('columnNameName'),
                        sortable: true,
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'owsType',
                        label: this.$t('columnTypeTitle'),
                        sortable: false,
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'isUnavailable',
                        label: '',
                        sortable: false,
                        class: 'text-right',
                        thStyle: { border: 0 }
                    }
                ],
                records: [],
                searchText: '',
                selectedOwsServiceType: null
            };
        },

        computed: {
            $_owsServiceTypeOptions() {
                return owsServiceTypeOptions;
            },

            hasSearchValue() {
                return this.searchText && this.searchText.length > 0;
            },

            dataLoaded() {
                return this.records.length > 0;
            },

            filteredRecords() {
                let records = this.records;
                // filter records
                if (this.searchText && this.searchText.length > 0) {
                    const tokens = this.searchText.toLowerCase();
                    records = this.records.filter((record) => {
                        // search in name
                        return (
                            record.name.toLowerCase().includes(tokens) ||
                            // search in uri's
                            (record.uri_OGC &&
                                record.uri_OGC.toLowerCase().includes(tokens)) ||
                            (record.uri_WMS &&
                                record.uri_WMS.toLowerCase().includes(tokens)) ||
                            (record.uri_WFS &&
                                record.uri_WFS.toLowerCase().includes(tokens)) ||
                            (record.uri_WMTS &&
                                record.uri_WMTS.toLowerCase().includes(tokens))
                        );
                    });
                }
                // filter records on ows service type
                if (
                    this.selectedOwsServiceType &&
                    this.selectedOwsServiceType.length > 0
                ) {
                    records = records.filter((record) => {
                        return (
                            record.owsType.includes(this.selectedOwsServiceType) &&
                            record[`uri_${this.selectedOwsServiceType}`] &&
                            record[`uri_${this.selectedOwsServiceType}`].length > 0
                        );
                    });
                }
                return records;
            }
        },

        async beforeCreate() {
            nprogress.start();
            // get all ows data from the backend
            await this.$store
                .dispatch('useApiData', {
                    name: 'GetOwsOverview'
                })
                .then((result) => {
                    this.records = result.data;
                    // set OWS type
                    this.records.forEach((record) => {
                        record.owsType = getOwsType(record);
                    });
                    // set error icons
                    this.records.forEach((record) => {
                        if (record.unavailable) {
                            record.isUnavailable = 'fas fa-exclamation-triangle';
                        } else {
                            record.isUnavailable = null;
                        }
                    });

                    nprogress.done();
                });
        },

        methods: {
            $_onDetails(record) {
                this.$router.push({ path: `/dashboard/ows/detail/${record.id}` });
            },

            $_onInput(searchText) {
                this.searchText = searchText;
            },

            $_onOwsServiceType(input) {
                this.selectedOwsServiceType = input;
            },

            $_rowClass() {
                return 'tablerow';
            },

            $_clearFilters() {
                this.$_onInput('');
                this.$_onOwsServiceType(null);
            }
        }
    };
</script>

<style>
.error {
    color: red;
}
/*Following classes together remove the vertical line
        between the last two cells in each row
    */
#owsoverview.table-bordered td:nth-child(2) {
    border-right-width: 0px;
}

#owsoverview.table-bordered td:last-child {
    border-left-width: 0px;
}
</style>
